import { render } from "./MemberProfile.vue?vue&type=template&id=bbabdc74&ts=true"
import script from "./MemberProfile.vue?vue&type=script&lang=ts"
export * from "./MemberProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__